import { withViewModel } from '../../../../../infrastructure/components/with-view-model';
import { OrderBookingEmailsListPresentation } from './order-booking-emails-list.presentation';
import { OrderBookingEmailsListVM } from './order-booking-emails-list.viewmodel';

interface IProps {
    vm: OrderBookingEmailsListVM;
}

const OrderBookingEmailsListContainer = withViewModel(
    OrderBookingEmailsListPresentation,
    async (props: IProps) => {
        await props.vm.load();
        return props.vm;
    },
    () => []
);

export { OrderBookingEmailsListContainer as OrderBookingEmailsList };
